module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Qit6vO/media/FC-9789948817352.jpg?1684514382128",
      "alt": "This image is the cover for the book تستطيع"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("تستطيع\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("في داخلك يوجد صوت داخلي لا يمكنك إنكاره أو تجاهله، صوت أحلامك التي سجنتَها ظُلماً، وأمنياتك التي بعثتَها إلى ذاكرة النِّسيان، وطموحاتك التي لَم تنعم بأشعَّة الحقيقة. أعِدِ الاستماع إلى ذلك الصوت مرة أخرى.. إنَّه يدعوك للعودة مرَّة أخرى لمعركة الأحلام، ويطلب منك أن تعود مِن جديد لمحاولة تحقيق أهدافك. تجاهَل كلَّ تلك الأصوات المحبِطة التي تَصدُر مِن عالَمك الخارجي، وَاسْعَ لطَرِق أبواب أحلامك مرَّة أخرى. عُد إلى سفينة أحلامك، وكُن أنتَ قبطانها، وأَبحِر بها إلى موانئ السَّعادة.. هذه المرة ستكون لدَيك قوَّة أكبر لتحقيق الانتصار، فأنتَ تمتلك خبرة مِن محاولاتك السابقة ستُمَكِّنُك مِن تجنُّب الأسباب التي أدَّت لفشلك في محاولاتك السابقة لتحقِّق نجاحاً في محاولتك القادمة. رغم كلِّ الظروف التي تعصف بعالمك، رغم كلِّ الرياح التي تسعى لإبعاد سحابة أحلامك عن أرض سعادتك، كُن قويّاً، واسْعَ لترجمة أحلامك على أرض الواقع، كن رقماً صعباً في كلِّ تلك المعادلات التي سعَت لتصفيَتك مِن معادلة الحياة. تستطيع...")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      عصام المغيزوي\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("نبذةٌ عن الكاتب عصام بن راشد المغيزوي كاتبٌ ومبتكرٌ عماني الجنسيّة، وله العديد من المشاركاتِ المحليّة والعالميّة في مختلف المجالات، وقد حصدَ العديدَ من الجوائز على المستوى المحليّ في مجالَي، المقال الأدبي والبحث العلمي، كما تمّت دعوته لحضور مؤتمر الطّاقة النوويّة. ويميل في كتاباته الأدبيّة إلى مجالِ التنميةِ البشريّة؛ ليقينهِ التّام بأهمية هذا المجال في تحقيق الأهداف والأحلام.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0